import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Snowmobile Registration and Insurance' },
	{
		name: 'description',
		content: 'Snowmobile registration and insurance.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				Snowmobile Registration and Insurance
			</h1>
			<h3>Registration</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When a snowmobile is registered for the first time, it is assigned a
				registration number. The number stays with the sled from owner to owner
				until it is destroyed or permanently removed from NY. The DMV will
				provide registration number decals which must be displayed on both sides
				of the cowling of the sled at all times. The cowling is the forward
				portion of the sled that covers the engine and clutch assembly. Any
				other placement is illegal and can result in a costly citation. If a
				snowmobile was registered for the first time before August 1995, the
				owner-provided registration number must be displayed. Requirements
				dictate that the numbers must be at least three inches tall. Yearly
				registration validation stickers must be displayed in the upper
				left-hand corner of the registration decals.
			</p>
			<h3>Insurance</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Any snowmobile operated on any part of a roadway or shoulder of a
				highway in NY State must be covered by minimum liability insurance.
				These limits are $10,000 for bodily injury to any one person and $20,000
				for an accident involving two or more persons, as well as $5,000 in
				property damage liability arising from one accident. Proof of insurance
				must be carried by the snowmobiler and displayed on request. Contact us
				to learn more about obtaining insurance coverage for your snowmobile.
			</p>
			<h3>Registering your Sled</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Bring the following with you to the DMV to register your snowmobile:
			</p>
			<ul>
				<li>Completed form MV-82 ("Application for Vehicle Registration")</li>
				<li>
					Proof of Ownership: A Complete bill of sale and one of the following:
					<ul>
						<li>MCO/MSO for a new trailer, OR</li>
						<li>
							Signed title document for a 1973 or newer used trailer weighing
							over 1,000 lbs unloaded, OR
						</li>
						<li>
							Signed transferrable registration for a used trailer not requiring
							a title
						</li>
					</ul>
				</li>
				<li>
					Proof of payment of sales tax (tax may also be paid at the motor
					vehicle office)
				</li>
				<li>Proof of identity and date of birth</li>
				<li>A check made payable to the commissioner of motor vehicles.</li>
			</ul>
		</>
	)
}
